import React from "react";

const ScrollableContainer = ({ children, className }) => {
  return (
    <div
      className={`max-h-screen overflow-y-auto scrollbar-thin scrollbar-thumb-blue-500 scrollbar-track-gray-300 hover:scrollbar-thumb-blue-700 ${className}`}
    >
      {children}
    </div>
  );
};

export default ScrollableContainer;
